export default {
  mobile: "(max-width: 767px)",
  tablet: "(min-width: 768px) and (max-width: 991px)",
  desktop: "(min-width: 992px) and (max-width: 1200px)",
}
